import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { hasApiAudience, hasToken } from '@/helpers/connection-helper';
import { logoutUser } from '@/services/user';
var logout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(context && hasToken() && hasApiAudience({
            apiName: 'sts'
          }))) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return logoutUser(context);
        case 3:
          localStorage.removeItem('MDM_MAILS');
          localStorage.removeItem('MDM_ACCESS_TOKEN');
          localStorage.removeItem('MDM_CART_TOKEN');
          localStorage.removeItem('MDM_ORDER_ID');
          localStorage.removeItem('MDM_CONNECT_AS');
          localStorage.removeItem('MDM_USER_AUTHENTIFICATION');
          sessionStorage.removeItem('MDM_CART_ADDRESSES');
          sessionStorage.removeItem('MDM_CART_PHONE');
          sessionStorage.removeItem('MDM_RESTORE_CART');
          sessionStorage.removeItem('MDM_CC_ELIGIBLE');
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function logout(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default logout;